import React from "react";
import Button from "react-md/lib/Buttons/Button";
import { map } from "lodash";

const Buttons = ({ history, primary, buttons, className }) => {
  return (
    <div className={`flex-row flex-centered ${className}`}>
      {map(primary, (item, i) => (
        <Button
          key={i}
          raised
          className="btn btn-primary"
          label={item.label}
          onClick={() => {
            if (item.onClick) item.onClick();
            if (item.link) history.push(item.link);
          }}
        />
      ))}
      {map(buttons, (item, i) => (
        <Button
          key={i}
          raised
          className="btn"
          label={item.label}
          onClick={() => {
            if (item.onClick) item.onClick();
            if (item.link) history.push(item.link);
          }}
        />
      ))}
    </div>
  );
};

export default Buttons;



// WEBPACK FOOTER //
// ./src/components/Buttons.js